import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Receivable } from 'src/app/core/interfaces/receivable';

@Component({
  selector: 'app-receivable-modifications',
  templateUrl: './receivable-modifications.component.html',
  styleUrls: ['./receivable-modifications.component.scss']
})
export class ReceivableModificationsComponent implements OnInit {
  activeReceivable = [];
  arrayPending = [];
  arrayPaid = [];
  holder: {
    name: string,
    document: string,
    documentTypeName: string
  }
  constructor(
    public dialogRef: MatDialogRef<ReceivableModificationsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogParams: {
      holder?: {
        name: string,
        document: string,
        documentTypeName: string
      },
      listReceivables: Receivable[]
    },
  ) { }

  ngOnInit() {
    this.classifyReceivables();
    let notMeetRequirements = !this.dialogParams || !this.dialogParams.listReceivables || !this.dialogParams.listReceivables.length;
    if (notMeetRequirements) this.holder = this.dialogParams.holder;
    else {
      let receivableWithDebtor = this.dialogParams.listReceivables.find(receivable => !!(receivable.debtor && receivable.debtor.name));
      this.holder = receivableWithDebtor ? receivableWithDebtor.debtor : this.dialogParams.holder
    }
  }

  closeDialog(event) {
    if (event) this.dialogRef.close();
  }

  classifyReceivables() {
    if (this.dialogParams.listReceivables && this.dialogParams.listReceivables.length) {
      this.arrayPending = [];
      this.arrayPaid = [];
      // Recorremos el array original y clasificamos los objetos según el valor de "state"
      this.dialogParams.listReceivables.forEach(receivable => {
        const isPaid = receivable && receivable.state && receivable.state.description === 'paid';
        const hasActiveModification =
          receivable.modifications && receivable.modifications.length > 0 && receivable.modifications.some(
            m => m.state && m.state.description === 'Pending approval'
          );
        if (isPaid) this.arrayPaid.push(receivable);
        else if (hasActiveModification) this.activeReceivable.push(receivable);
        else this.arrayPending.push(receivable);
      });
    }
  }
}
